import { createContext } from 'react'
import { GoogleSession, OneLoginSession } from '../../types'

interface AuthContextType {
  login: (
    _session: GoogleSession | OneLoginSession,
    _role: string | null,
  ) => Promise<void>
  logout: () => Promise<void>
  session: GoogleSession | OneLoginSession | null
  role: string | null
  permissions: string[]
  moduleManagerToken: string | null
  moduleManagerTokenType: string
  hasPermission: (_permission: string) => boolean
  getToken: () => string | null
  isLoaded: boolean
}

export const AuthContext = createContext<AuthContextType>({
  login: async () => {
    // initial state
  },
  logout: async () => {
    // initial state
  },
  session: null,
  role: null,
  permissions: [],
  moduleManagerToken: null,
  moduleManagerTokenType: 'Bearer',
  hasPermission: (_permission: string) => false,
  getToken: () => null,
  isLoaded: false,
})
